<template>
  <div class="courses-container main-view">
    <div class="container">
      <div>
        <div>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="15" :md="15" :lg="15" :xl="15">
              <div>
                <VideoCourses :data-object="dataLink" :is-loading="false" />
              </div>
              <div class="desktop">
                <h4 class="title mt-10">
                  {{ title }}
                </h4>
                <div class="info-teacher flex align-center">
                  <img
                    class="img-teacher mr-10 "
                    :src="infoData.author?.avatar || img.ImageTeacher"
                    alt=""
                  />
                  <div>
                    <p class="m-0 fw-600 c-body2">
                      {{ infoData.author?.fullname }}
                    </p>
                    <p style="color: #8E9195;" class="m-0">California, USA</p>
                  </div>
                </div>
                <div>
                  <div class="flex justify-flex-start mt-20">
                    <div class="flex overview  align-center">
                      <img class="mr-5" :src="icons.StarIcon" alt="" />
                      <span class="mr-5 mt-5 span-over">{{
                        infoData.avg_star || 5
                      }}</span>
                      <span class="mt-5 span-over" style="color: #8E9195;"
                        >(12 rating)</span
                      >
                    </div>
                    <div class="flex overview align-center">
                      <img class="mr-5" :src="icons.HatIcon" alt="" />
                      <span class="mt-5 span-over" style="color: #8E9195;"
                        >{{ infoData.chapters?.length }} Chapters
                      </span>
                    </div>
                    <div class="flex align-center">
                      <img class="mr-5" :src="icons.UserIcon" alt="" />
                      <span class="mt-5 span-over" style="color: #8E9195;"
                        >{{
                          formatNumber(infoData.num_subscribers)
                        }}
                        students</span
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="mt-10"
                  style="height: 1px; background:#E3E3E3"
                ></div>
                <div class="mt-20">
                  <h4 class="fw-600 c-body2">OVERVIEW</h4>
                  <div style="margin-top: 40px;" class="mt-20">
                    <h4 class="fw-600 c-title1">What will be learned</h4>
                    <el-row style="margin-top: 30px;" :gutter="20">
                      <el-col
                        style="min-height:60px;"
                        v-for="(objectives, index) in infoData.objectives"
                        :key="index"
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        :xl="12"
                      >
                        <div class="flex align-center mb-20">
                          <img class="mr-10" :src="icons.CheckBoxIcon" alt="" />
                          <span
                            style="font-size: 13px; color: #494949; line-height:1.5"
                          >
                            {{ objectives }}</span
                          >
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  class="mt-20 mb-20"
                  style="height: 30px; border-top: 1px solid #E3E3E3; border-bottom: 1px solid #E3E3E3"
                ></div>
              </div>
            </el-col>
            <el-col class="desktop" :xs="24" :sm="9" :md="9" :lg="9" :xl="9">
              <div class="info-container">
                <div class="courses-includes">
                  <DescribeCourses :info="infoData" />
                </div>
                <div>
                  <button
                    v-if="!is_purchase"
                    @click="handleAddCard"
                    class="add-courses"
                  >
                    Buy Now ( {{ formatNumber(this.infoData.payment_amount) }}$ )
                  </button>
                </div>
                <div class="list-section-container">
                  <Sections
                    :is-purchase="is_purchase"
                    :data-sections="sections"
                    @on-get-title="val => (title = val)"
                    @on-asset-link="handleOnAssetLink"
                  />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="mobile" style="min-height: 500px;">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <!-- <div v-if="isShowVideoMobi">
              <VideoCourses :data-object="dataLink" :is-loading="false" />
            </div> -->

              <h4 class="title mt-10">
                {{ title }}
              </h4>
              <div class="info-teacher flex align-center">
                <img
                  class="img-teacher mr-10 "
                  :src="infoData.author?.avatar || img.ImageTeacher"
                  alt=""
                />
                <div>
                  <p class="m-0 fw-600 c-body2">
                    {{ infoData.author?.fullname }}
                  </p>
                  <p style="color: #8E9195;" class="m-0">California, USA</p>
                </div>
              </div>
              <div>
                <div class="flex justify-flex-start mt-20">
                  <div class="flex overview  align-center">
                    <img class="mr-5" :src="icons.StarIcon" alt="" />
                    <span class="mr-5 mt-5 span-over">{{
                      infoData.avg_star || 5
                    }}</span>
                    <span class="mt-5 span-over" style="color: #8E9195;"
                      >(12 rating)</span
                    >
                  </div>
                  <div class="flex overview align-center">
                    <img class="mr-5" :src="icons.HatIcon" alt="" />
                    <span class="mt-5 span-over" style="color: #8E9195;"
                      >{{ infoData.chapters?.length }} Chapters
                    </span>
                  </div>
                  <div class="flex align-center">
                    <img class="mr-5" :src="icons.UserIcon" alt="" />
                    <span class="mt-5 span-over" style="color: #8E9195;"
                      >{{
                        formatNumber(infoData.num_subscribers)
                      }}
                      students</span
                    >
                  </div>
                </div>
              </div>
              <div class="mt-10" style="height: 1px; background:#E3E3E3"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="info-container">
                <div>
                  <button
                    v-if="!is_purchase"
                    @click="handleAddCard"
                    class="add-courses"
                  >
                    Buy Now ( {{ formatNumber(this.infoData.payment_amount) }}$ )
                  </button>
                </div>
                <div class="list-section-container">
                  <Sections
                    :is-purchase="is_purchase"
                    :data-sections="sections"
                    @on-get-title="val => (title = val)"
                    @on-asset-link="handleOnAssetLink"
                  />
                </div>

                <div class="mt-20">
                  <div style="margin-top: 40px;" class="mt-20">
                    <div class="courses-includes">
                      <DescribeCourses :info="infoData" />
                    </div>

                    <h4 style="margin-top: 40px;" class="fw-600  c-title1">
                      What will be learned
                    </h4>
                    <el-row style="margin-top: 20px;" :gutter="20">
                      <el-col
                        style="min-height:60px;"
                        v-for="(objectives, index) in infoData.objectives"
                        :key="index"
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        :xl="12"
                      >
                        <div class="flex align-center mb-20">
                          <img class="mr-10" :src="icons.CheckBoxIcon" alt="" />
                          <span
                            style="font-size: 13px; color: #494949; line-height:1.5"
                          >
                            {{ objectives }}</span
                          >
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div
                  class="mt-20 mb-20"
                  style="height: 30px; border-top: 1px solid #E3E3E3; border-bottom: 1px solid #E3E3E3"
                ></div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24"> </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="dialog-container">
      <DialogNoti
        :show-dialog="showDialog"
        :text-msg="messageNoti"
        @on-close-dialog="showDialog = false"
      />
    </div>
  </div>
</template>
<script>
import VideoCourses from "@/views/pages/Courses/components/Video";
import ImageTeacher from "@/assets/img/img_edu/Video.png";
import StarIcon from "@/assets/img/svg_edu/star.svg";
import UserIcon from "@/assets/img/svg_edu/UserIcon.svg";
import HatIcon from "@/assets/img/svg_edu/HatIcon.svg";
import CheckBoxIcon from "@/assets/img/svg_edu/CheckBox.svg";
import DescribeCourses from "@/views/pages/Courses/components/Describe.vue";
import Sections from "@/views/pages/Courses/components/Section.vue";
import CoursesResource from "@/views/api/courses";
import { formatNumber } from "@/utils/formatData";
import { isEmpty } from "@/utils/validate";
import { setCart, setOrder, getCart } from "@/utils/orders";
import CoursesPurchaseResource from "@/views/api/course-purchase.js";
import { getPageTitle } from "@/utils/helper";
import DialogNoti from "@/views/components/DialogNoti.vue";

export default {
  name: "detai-courses",
  props: {},
  components: {
    VideoCourses,
    DescribeCourses,
    Sections,
    DialogNoti
  },
  created() {
    if (this.$route.query.transaction_id) {
      this.handleConfirmPayment();
    }
    this.onGetDetail();
  },
  mounted() {
    // Bắt sự kiện resize khi component được mounted
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  data() {
    return {
      messageNoti: "",
      showDialog: false,
      isShowVideoMobi: false,
      is_purchase: true,
      title: "",
      dataLink: {},
      loading: false,
      courses_id: this.$route.params.coursesId,
      sections: [],
      infoData: {},
      img: {
        ImageTeacher
      },
      icons: {
        HatIcon,
        UserIcon,
        StarIcon,
        CheckBoxIcon
      }
    };
  },

  watch: {},
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    this.updateOpenGraphMeta("Học vi vu", "https://hocvivu.com/Logo.png");
    getPageTitle();
  },
  methods: {
    handleConfirmPayment() {
      CoursesPurchaseResource.CheckTransaction({
        transaction_id: this.$route.query.transaction_id
      })
        .then(res => {
          // const { error_code, data, error_msg } = res;
          if (res.error_code !== 0) {
            this.$message.error(res.error_msg);
            return;
          }
          this.showDialog = true;
          this.messageNoti = res.data.message;
        })
        .finally(() => {
          const query = { ...this.$route.query };
          delete query.transaction_id;
          this.$router.replace({ query });
        });
    },
    updateOpenGraphMeta(title, image) {
      // Tìm thẻ meta với property="og:title" và cập nhật nội dung
      const ogTitleMeta = document.querySelector('meta[property="og:title"]');
      if (ogTitleMeta) {
        ogTitleMeta.content = title;
      }
      const ogImageMeta = document.querySelector('meta[property="og:image"]');
      if (ogImageMeta) {
        ogImageMeta.content = image;
      }
    },
    handleResize() {
      // Cập nhật giá trị chiều rộng màn hình khi sự kiện resize xảy ra
      const currentWidth = window.innerWidth;
      if (currentWidth < 770) {
        this.isShowVideoMobi = true;
      } else {
        this.isShowVideoMobi = false;
      }
    },
    handleOnAssetLink(val) {
      console.log("vào đây________", val);
      this.dataLink = { ...val };
    },
    onGetDetail() {
      this.loading = true;
      CoursesResource.Detail({ course_id: this.courses_id })
        .then(res => {
          const { error_code, data } = res;
          if (error_code !== 0) return;
          this.infoData = data;
          this.is_purchase = data.is_purchase;
          this.title = data.headline;
          this.updateOpenGraphMeta(data.headline, data.banner);
          this.$logEvent(this.$analytics, "view_course_detail", {
            course_name: `ID:${this.courses_id} -  ${data.headline}`
          });
          getPageTitle(data.headline);
          this.sections =
            data.chapters.length > 0
              ? data.chapters.map(i => ({ ...i, isShow: false }))
              : [];
          if (data.chapters.length > 0) {
            const linkVideoFirst = data.chapters
              ?.map(c => c.lectures)
              ?.flat()
              ?.find(
                lecture =>
                  lecture.asset.asset_type === "Video" && lecture.is_free
              );
            console.log("linkVideoFirst______", linkVideoFirst);
            if (!isEmpty(linkVideoFirst)) {
              this.handleGetLinkVideo(linkVideoFirst.lecture_id);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleGetLinkVideo(lecture_id) {
      console.log("vào đây mấy lần");
      this.dataLink = {
        isShow: false,
        isLoading: true
      };
      CoursesResource.AssetLink({ lecture_id }).then(res => {
        const { error_code, data, error_msg } = res;
        if (error_code === 0) {
          console.log(data);
          this.dataLink = {
            isShow: !this.isShowVideoMobi,
            isLoading: false,
            url_link: data.link
          };
        }
      });
    },
    async handleAddCard() {
      const res = await this.onGetPaymentAmount(this.infoData?.course_id);
      if (res.error_code !== 0) {
        this.$message.warning(res.error_msg);
        return;
      }
      const data = {
        author: this.infoData?.author || {},
        course_id: this.infoData?.course_id,
        discount_amount: this.infoData.discount_amount || 0,
        payment_amount: this.infoData.payment_amount,
        origin_amount:
          this.infoData.discount_amount + this.infoData.payment_amount,
        headline: this.infoData?.headline,
        banner: this.infoData?.banner
      };
      console.log("data __________", data);
      setOrder([data]);
      setCart([data, ...getCart()]);
      return this.$router.push("/Orders");
    },
    async onGetPaymentAmount(course_id) {
      const body = { course_ids: [course_id] };
      const res = await CoursesPurchaseResource.GetPaymentAmount(body);
      return res;
    },
    formatNumber
  }
};
</script>
<style scoped>
.overview {
  min-width: 150px;
}
.add-courses {
  border-radius: 32px;
  background-color: #035ae0;
  color: #ffff;
  width: 100%;
  min-height: 48px;
  font-weight: 600;
  font-size: 16px;
  margin: 20px 0;
}
.info-container {
  padding: 20px;
  box-shadow: 0px 20px 40px 0px #0000000f;
  width: 100%;
  background: #fff;
}
.img-teacher {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.title {
  font-size: 25px;
  font-weight: 700;
  line-height: 1;
  text-align: left;
  margin: 15px 0;
  padding: 0;
}
.courses-container {
}
.main-view {
  padding-top: 100px;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .span-over {
    font-size: 12px;
  }
  .overview {
    min-width: 100px;
  }
  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
    text-align: left;
    margin: 15px 0;
    padding: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 4.5em; /* 3 lines * 1.5 line-height */
  }
}
</style>
